import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BrainCircuit, FileUp, ShieldCheck, Sparkles, UserRound } from 'lucide-react';

const options = [
  {
    mode: 'manual',
    icon: UserRound,
    title: 'Create Profile',
    description: 'Enter your education, skills, and projects with a guided form built for clean career data.',
    accent: 'from-purple-600 to-pink-600',
    meta: 'Best for first-time setup',
  },
  {
    mode: 'resume',
    icon: FileUp,
    title: 'Upload Resume',
    description: 'Upload a PDF, DOC, or DOCX resume up to 5MB and let AIVION extract your profile foundation.',
    accent: 'from-purple-600 to-pink-600',
    meta: 'Fast AI-assisted import',
  },
];

const ProfileChoice = ({ onSelect }) => {
  return (
    <section className="grid gap-5 lg:grid-cols-2">
      {options.map((option, index) => (
        <motion.button
          key={option.mode}
          type="button"
          onClick={() => onSelect(option.mode)}
          initial={{ opacity: 0, y: 22 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.42, delay: index * 0.08 }}
          whileHover={{ y: -6, scale: 1.01 }}
          whileTap={{ scale: 0.98 }}
          className="group relative overflow-hidden rounded-2xl border border-slate-700/50 bg-slate-800/50 p-6 text-left shadow-2xl shadow-purple-950/30 backdrop-blur-xl transition hover:border-purple-400/60 hover:shadow-purple-500/20 sm:p-7"
        >
          <div className={`absolute inset-x-0 top-0 h-1 bg-gradient-to-r ${option.accent}`} />
          <div className="absolute -right-14 -top-16 h-40 w-40 rounded-full bg-pink-500/10 blur-3xl transition group-hover:bg-pink-500/20" />
          <div className="relative">
            <div className="mb-6 flex items-center justify-between">
              <span className={`flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br ${option.accent} text-white shadow-lg shadow-purple-500/25`}>
                <option.icon className="h-7 w-7" />
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full border border-slate-700/50 bg-slate-900/50 px-3 py-1 text-xs font-semibold text-gray-300">
                <Sparkles className="h-3.5 w-3.5 text-purple-300" />
                {option.meta}
              </span>
            </div>
            <h2 className="text-2xl font-bold text-white">{option.title}</h2>
            <p className="mt-3 min-h-14 text-sm leading-6 text-gray-400">{option.description}</p>
            <div className="mt-7 flex items-center justify-between border-t border-slate-700/50 pt-5">
              <span className="inline-flex items-center gap-2 text-sm font-semibold text-purple-300">
                {option.mode === 'manual' ? <BrainCircuit className="h-4 w-4" /> : <ShieldCheck className="h-4 w-4" />}
                Personalize roadmap
              </span>
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition group-hover:bg-gradient-to-r group-hover:from-purple-600 group-hover:to-pink-600">
                <ArrowRight className="h-5 w-5" />
              </span>
            </div>
          </div>
        </motion.button>
      ))}
    </section>
  );
};

export default ProfileChoice;
